import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const TextInput = ({ state, value, placeholder, disabled, onChange, dataAttrId }) => {
  const [currentValue, setCurrentValue] = useState(value)

  const handleChange = (evt) => {
    if (!disabled) {
      const newValue = evt.target.value
      onChange(newValue)
      if (state) {
        setCurrentValue(newValue)
      }
    } 
  }

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  const inputValue = state ? currentValue : value

  return (
    <input
      type='text'
      value={inputValue}
      placeholder={placeholder}
      disabled={disabled}
      onChange={handleChange}
      {...(dataAttrId ? { 'data-attribute-id': dataAttrId } : {})}
    />
  )
}

TextInput.propTypes = {
  state: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  dataAttrId: PropTypes.string
}

TextInput.defaultProps = {
  state: true,
  value: '',
  placeholder: '',
  disabled: false,
  onChange: (e) => {}, // This is intentional
  dataAttrId: ''
}

export default TextInput
